import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalculatorResultWrapper } from '../../../models/analysis/calculator-result-wrapper';
import { SavePlantResponse } from '../../../models/analysis/save-plant-response';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LoaderService } from '../../../../services/loader.service';
import { AnalysisService } from '../../../../services/analysis.service';
import { ToastService } from '../../../../services/toast.service';
import { AuthService } from '../../../../services/auth/auth.service';
import { PowerPlantFormData } from '../model/power-plant-form-data';
import { PriceType } from '../../../models/price/price';
import { UserRole } from '../../../models/user/user-role.enum';
import { finalize } from 'rxjs';
import { fileSizeValidator, fileTypeValidator } from '../../../validators';
import { SharedModule } from '../../../shared.module';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'psc-save-power-plant-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, SharedModule, TranslocoModule],
  templateUrl: './save-power-plant-form.component.html',
})
export class SavePowerPlantFormComponent implements OnInit {
  resultWrapper: CalculatorResultWrapper;

  @Input() buttonText: string;
  @Input()
  set calculatorResultWrapper(value: CalculatorResultWrapper) {
    this.resultWrapper = value;
    this.initForm();
  }

  get calculatorResultWrapper(): CalculatorResultWrapper {
    return this.resultWrapper;
  }

  @Output() plantSaved: EventEmitter<SavePlantResponse> = new EventEmitter<SavePlantResponse>();
  @Output() canceled: EventEmitter<void> = new EventEmitter<void>();

  formGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private loaderService: LoaderService,
    private analysisService: AnalysisService,
    private toastService: ToastService,
    private changeDetectorRef: ChangeDetectorRef,
    private authService: AuthService,
  ) {
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    const userData = this.authService.getUserDataValue();

    this.formGroup = this.formBuilder.group({
      name: ['', Validators.required],
      investor: [`${ userData?.firstName } ${ userData?.lastName }`, Validators.required],
      address: ['', Validators.required],
      image: ['', [fileTypeValidator(['jpg', 'jpeg', 'png']), fileSizeValidator(2048)]],
    });

  }

  submit() {
    if (!this.formGroup.valid) {
      return;
    }
    this.loaderService.showLoader();
    const image = this.formGroup.controls['image'].value[0];
    const powerPlantFormData: PowerPlantFormData = new PowerPlantFormData({
      projectName: this.formGroup.controls['name'].value,
      investorName: this.formGroup.controls['investor']?.value,
      address: this.formGroup.controls['address'].value,
    }, this.calculatorResultWrapper, image);

    const analysisMethod =  this.analysisService.savePowerPlant(powerPlantFormData.formData);

    analysisMethod.pipe(
      finalize(() => {
        this.loaderService.hideLoader();
      }),
    ).subscribe((response) => {
      this.plantSaved.emit(response);
      this.initForm();
      this.changeDetectorRef.detectChanges();
      /**
       * t(calculator_result.save_power_plant.saved)
       */
      this.toastService.showSuccessToast('calculator_result.save_power_plant.saved');
    });
  }
}
